module.exports = __webpack_public_path__ + "img/delAccBtn.92fe80ef.png";